import { useCroptimizer } from 'features/Croptimizer/providers/CroptimizerContext';

import { useTranslation } from 'react-i18next';

import plusIcon from '/plusBlue.svg';

export const TabBar = ({
  addField,
  isPDF,
}: {
  addField: (isOnlyOne?: boolean) => () => void;
  isPDF?: boolean;
}) => {
  const { t } = useTranslation();
  const { fields, activeTabCrop, setActiveTabCrop } = useCroptimizer();

  return (
    <div className="flex flex-wrap">
      {fields?.map((field, i) => (
        <div
          onClick={() => setActiveTabCrop(field.id)}
          key={i}
          className="flex flex-col mr-10"
        >
          <div
            className={`${
              activeTabCrop === field.id
                ? 'text-black font-bold'
                : 'text-secondaryText'
            } md:text-lg cursor-pointer`}
          >
            {field.title ? field.title : t('field')}
          </div>

          <div
            className={`${
              activeTabCrop === field.id ? 'bg-primary' : 'bg-blue50'
            } w-full h-[2px] rounded my-[5px] mt-1`}
          />
        </div>
      ))}
      {!isPDF && (
        <div
          onClick={() => addField()()}
          className="flex items-center mb-[8px] md:mb-0 cursor-pointer"
        >
          <img className="w-[14px] h-[14px] mr-2" src={plusIcon} alt="" />
          <div className="text-primary">{t('addField')}</div>
        </div>
      )}
    </div>
  );
};
